var _rect, _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotPoint3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#262222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 30,
    fill: "#342F2F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 23.3333,
    fill: "#171616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_918)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F26D6B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 53,
    cy: 27.5,
    r: 7.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_918"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotPoint3);
export default __webpack_public_path__ + "static/media/robot_point_3.3bec3d6a54d82846e709ea01400ce034.svg";
export { ForwardRef as ReactComponent };